type ValidationRule = {
  value: number;
  message: string;
};

type ValidationRules = {
  minLength?: ValidationRule;
  maxLength?: ValidationRule;
};

type GetMinMaxValidationRulesOptions = {
  label: string;
  min?: number;
  max?: number;
};

export function getMinMaxValidationRules(options: GetMinMaxValidationRulesOptions): ValidationRules {
  const { label, min, max } = options;

  if (min != null && max != null && min > max) {
    throw new RangeError("min must be less than or equal to max");
  }

  const rules: ValidationRules = {};

  if (min != null) {
    const message = min === max ? `${label} must be exactly ${min} digits` : `${label} must be at least ${min} digits`;
    rules.minLength = { value: min, message };
  }

  if (max != null) {
    const message = min === max ? `${label} must be exactly ${max} digits` : `${label} must be at most ${max} digits`;
    rules.maxLength = { value: max, message };
  }

  return rules;
}
